import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import { formatReservationName } from './attendanceInquiryUtils';
import messages from './AttendanceInquiryModal.messages';
import './AttendanceInquiryModal.scss';

const { element } = bem('attendance-inquiry-summary');

const ReservationCard = ({ inquiry }) => {
  const formatDateTime = date => {
    if (!date) return '';
    return format(new Date(date), 'MMMM d, yyyy');
  };

  const formatTime = date => {
    if (!date) return '';
    return format(new Date(date), 'h:mm a');
  };

  return (
    <div className={element('reservation-card')}>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.userName} />
        </span>
        <span className={element('card-value')}>{inquiry.userName}</span>
      </div>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.reservationName} />
        </span>
        <span className={element('card-value')}>{formatReservationName(inquiry.reservationName)}</span>
      </div>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.date} />
        </span>
        <span className={element('card-value')}>{formatDateTime(inquiry.reservationDatetime)}</span>
      </div>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.time} />
        </span>
        <span className={element('card-value')}>{formatTime(inquiry.reservationDatetime)}</span>
      </div>
    </div>
  );
};

ReservationCard.propTypes = {
  inquiry: PropTypes.shape({
    inquiryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    userName: PropTypes.string,
    reservationName: PropTypes.string,
    reservationDatetime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
};

export default ReservationCard;
